import { IconType } from '@/types/common';

import { ANIMATION_NAME_REGEX, SCREEN_BREAKPOINT_NAMES } from './constants';

export const pickAssetForCurrentBreakpoint = (
  breakpoint: SCREEN_BREAKPOINT_NAMES,
  assets: {
    small: IconType;
    medium: IconType;
    large: IconType;
  }
) => {
  const { small, medium, large } = assets!;
  switch (breakpoint) {
    case SCREEN_BREAKPOINT_NAMES.small:
      return small || medium || large;
    case SCREEN_BREAKPOINT_NAMES.medium:
      return medium || large || small;
    default:
      return large || medium || small;
  }
};

export const fetchJsonAnimation = async (url: string) => {
  return await fetch(url)
    .then(res => (res.ok ? res.json() : Promise.reject(res)))
    .then(json => {
      return json;
    })
    .catch(() => {
      console.error('Unable to resolve json file');
      return null;
    });
};

const findKeyByRegex = (object: Record<string, any>, regex: RegExp) => {
  return Object.keys(object).find(key => {
    if (key.match(regex)) {
      return key;
    }
    return false;
  });
};

export const fetchLottieAnimation = async (url: string) => {
  if (!window.JSZip) {
    console.error('JSZip is not loaded');
    return null;
  }

  return fetch(url)
    .then(res => (res.ok ? res.blob() : Promise.reject(res)))
    .then(blob => {
      return window.JSZip.loadAsync(blob).then(zip => {
        const animationFileName = findKeyByRegex(
          zip.files,
          ANIMATION_NAME_REGEX
        );
        if (!animationFileName) {
          console.error('Invalid lottie animation data');
          return null;
        }

        return zip
          .file(animationFileName)
          ?.async('string')
          .then(animation => {
            return JSON.parse(animation);
          });
      });
    })
    .catch(e => {
      console.error('Unable to resolve lottie file', e);
      return null;
    });
};
